module.exports = __webpack_public_path__ + "img/Dantam Makeover 10.755ad32f.jpg";